import React, { useEffect, useState } from "react";
import {
  Table,
  Button,
  Modal,
  Form,
  Input,
  InputNumber,
  Select,
  Space,
  Tag,
  Popconfirm,
} from "antd";
import { PlusOutlined, EditOutlined, DeleteOutlined } from "@ant-design/icons";

const { Option } = Select;

const MedicineMaster = () => {
  const [form] = Form.useForm();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [editingRecord, setEditingRecord] = useState(null);

  // 🔹 Simulate API fetch
  useEffect(() => {
    fetchMedicines();
  }, []);

  const fetchMedicines = () => {
    setLoading(true);
    // Replace with API call
    setTimeout(() => {
      setData([
        {
          id: 1,
          medicineName: "Paracetamol",
          dosage: "500mg",
          orderType: "Tablet",
          price: 15.5,
          status: "Active",
        },
        {
          id: 2,
          medicineName: "Amoxicillin",
          dosage: "250mg",
          orderType: "Capsule",
          price: 35.0,
          status: "Active",
        },
      ]);
      setLoading(false);
    }, 500);
  };

  // 🔹 Open modal (for create / edit)
  const openModal = (record = null) => {
    setEditingRecord(record);
    if (record) {
      form.setFieldsValue(record);
    } else {
      form.resetFields();
    }
    setModalOpen(true);
  };

  // 🔹 Save medicine (create / update)
  const handleSave = () => {
    form.validateFields().then((values) => {
      if (editingRecord) {
        // Update existing
        const updated = data.map((item) =>
          item.id === editingRecord.id ? { ...editingRecord, ...values } : item
        );
        setData(updated);
      } else {
        // Create new
        const newMedicine = {
          id: data.length ? data[data.length - 1].id + 1 : 1,
          ...values,
          status: "Active",
        };
        setData([...data, newMedicine]);
      }
      setModalOpen(false);
      setEditingRecord(null);
    });
  };

  // 🔹 Delete medicine
  const handleDelete = (id) => {
    setData(data.filter((item) => item.id !== id));
  };

  const columns = [
    { title: "S No", dataIndex: "sno", render: (_, r, i) => i + 1 },
    { title: "Medicine Name", dataIndex: "medicineName" },
    { title: "Dosage", dataIndex: "dosage" },
    { title: "Order Type", dataIndex: "orderType" },
    {
      title: "Price",
      dataIndex: "price",
      render: (price) => `₹${price.toFixed(2)}`,
    },
    {
      title: "Status",
      dataIndex: "status",
      render: (status) => (
        <Tag color={status === "Active" ? "green" : "red"}>{status}</Tag>
      ),
    },
    {
      title: "Actions",
      render: (_, record) => (
        <Space>
          <Button icon={<EditOutlined />} onClick={() => openModal(record)} />
          <Popconfirm
            title="Delete Medicine?"
            onConfirm={() => handleDelete(record.id)}
          >
            <Button icon={<DeleteOutlined />} danger />
          </Popconfirm>
        </Space>
      ),
    },
  ];

  return (
    <div style={{ padding: 20 }}>
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <h2>Medicine Master</h2>
        <Button
          type="primary"
          icon={<PlusOutlined />}
          style={{ marginBottom: 16 }}
          onClick={() => openModal()}
        >
          Add Medicine
        </Button>
      </div>
      <Table
        dataSource={data}
        columns={columns}
        rowKey="id"
        loading={loading}
      />

      {/* Modal for Create / Update */}
      <Modal
        title={editingRecord ? "Edit Medicine" : "Add Medicine"}
        open={modalOpen}
        onCancel={() => setModalOpen(false)}
        onOk={handleSave}
        okText="Save"
      >
        <Form form={form} layout="vertical">
          <Form.Item
            name="medicineName"
            label="Medicine Name"
            rules={[{ required: true, message: "Enter medicine name" }]}
          >
            <Input />
          </Form.Item>

          <Form.Item
            name="dosage"
            label="Dosage"
            rules={[{ required: true, message: "Enter dosage" }]}
          >
            <Input />
          </Form.Item>

          <Form.Item
            name="orderType"
            label="Order Type"
            rules={[{ required: true, message: "Select order type" }]}
          >
            <Select placeholder="Select order type">
              <Option value="Tablet">Tablet</Option>
              <Option value="Capsule">Capsule</Option>
              <Option value="Syrup">Syrup</Option>
              <Option value="Injection">Injection</Option>
            </Select>
          </Form.Item>

          <Form.Item
            name="price"
            label="Price"
            rules={[{ required: true, message: "Enter price" }]}
          >
            <InputNumber
              style={{ width: "100%" }}
              min={0}
              step={0.5}
              formatter={(val) => `₹ ${val}`}
            />
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default MedicineMaster;
